export const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : `https://${
        process.env.REACT_APP_SUBDOMAIN ? process.env.REACT_APP_SUBDOMAIN + '.' : ''
      }linkdle.com`
